import { SfLog } from '@app/adapters/logger'

// Parses a JSON array rendered by Rails into a data attribute. Anything that
// is not a JSON array (missing attribute, malformed payload) becomes an empty
// list, with a warning so a bad server payload does not pass silently.
export function parseDatasetList<T>(value?: string): T[] {
  if (!value) return []
  try {
    const parsed: unknown = JSON.parse(value)
    return Array.isArray(parsed) ? (parsed as T[]) : []
  } catch (e) {
    SfLog.warn('Failed to parse dataset list', { error: e, extra: { value } })
    return []
  }
}
